import {AP_SURVEY_ANNUAL_EVENT_TYPE_ID} from '../../helpers/misc'
import {AP_SURVEY_QUESTIONS_ANNUAL_CONTROL} from "../../helpers/misc_survey"
import {SurveyCards} from "./SurveyCards"
import {SurveyTextarea, YesOrNoRadios} from './Survey'

export class SurveyAnnualControlCards extends SurveyCards  {

  state = {
    ...this.getDefaultState(),
    bigQuestions: [20],
    questions: AP_SURVEY_QUESTIONS_ANNUAL_CONTROL,
  }

  async componentDidMount() {
    void this.getDataForForm(AP_SURVEY_ANNUAL_EVENT_TYPE_ID)
  }


  getItems = ({ gender, questions, setSurveyAnswer }) => {
    return [
      {
        header: "Dotazník - Roční prohlídka",
        title: <>Vyplněním všech otázek si významně zkrátíte čas, který byste strávili vyplněním otázek v dárcovském centru. Uvedené údaje nejsou povinné. Pokud si nejste u některé z otázek jistí odpovědí, otázku prosím nevyplňujte. Podrobné poučení pro dárce naleznete <a href='https://www.amberplasma.com/file/1144' target='_blank'>zde</a>. Platnost vyplněného dotazníku je 48 hodin, nevyplňujte dříve než 48 hodin před Vašim darováním!</>,
        description: <span className="first-description">Dotazník vám zabere <strong>cca 10 minut.</strong></span>
      },
      {
        className: questions.q1.answer !== undefined ? "step-open-by-default" : null,
        title: gender !== "2" ? questions.q1.question : questions.q1.question_female,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q2.question : questions.q2.question_female,
        className: questions.q2.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q2"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q2.answer === true &&

            <SurveyTextarea skey={"q2z"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          }


        </div>
      },
      {
        title: gender !== "2" ? questions.q3.question : questions.q3.question_female,
        className: questions.q3.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q3"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q4.question : questions.q4.question_female,
        className: questions.q4.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q4"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q5.question : questions.q5.question_female,
        className: questions.q5.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q5"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q5.answer === true &&

            <SurveyTextarea skey={"q5z"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          }


        </div>
      },
      {
        title: gender !== "2" ? questions.q6.question : questions.q6.question_female,
        className: questions.q6.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q6"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q7.question : questions.q7.question_female,
        className: questions.q7.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q7"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q7.answer === true &&
            <>
              <SurveyTextarea skey={"q7z1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
              <SurveyTextarea skey={"q7z2"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
            </>
          }


        </div>
      },
      {
        title: gender !== "2" ? questions.q8.question : questions.q8.question_female,
        className: questions.q8.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q8"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q8.answer === true &&

            <SurveyTextarea skey={"q8z1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          }

        </div>
      },
      {
        title: gender !== "2" ? questions.q9.question : questions.q9.question_female,
        className: questions.q9.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q9"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q10.question : questions.q10.question_female,
        className: questions.q10.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q10"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q10.answer === true &&

            <SurveyTextarea skey={"q10z"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          }


        </div>
      },
      {
        title: gender !== "2" ? questions.q11.question : questions.q11.question_female,
        className: questions.q11.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q11"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q12.question : questions.q12.question_female,
        className:  questions.q12.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q12"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q13.question : questions.q13.question_female,
        className: questions.q13.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q13"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q14.question : questions.q14.question_female,
        className: questions.q14.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q14"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q14.answer === true &&

            <SurveyTextarea skey={"q14z"} gender={gender} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          }


        </div>
      },
      {
        title: gender !== "2" ? questions.q15.question : questions.q15.question_female,
        className: questions.q15.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q15"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q16.question : questions.q16.question_female,
        className: questions.q16.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q16"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q17.question : questions.q17.question_female,
        className: questions.q17.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q17"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q18.question : questions.q18.question_female,
        className: questions.q18.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q18"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


        </div>
      },
      {
        title: gender !== "2" ? questions.q19.question : questions.q19.question_female,
        className: questions.q19.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q19"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q19.answer === true &&

            <SurveyTextarea skey={"q19z"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          }


        </div>
      },
      {
        title: gender !== "2" ? questions.q20.question : questions.q20.question_female,
        className: (questions.q20a1.answer !== undefined ||
          questions.q20a2.answer !== undefined ||
          questions.q20a3.answer !== undefined ||
          questions.q20a4.answer !== undefined ||
          questions.q20a5.answer !== undefined ||
          questions.q20b1.answer !== undefined ||
          questions.q20c1.answer !== undefined ||
          questions.q20d1.answer !== undefined ||
          questions.q20e1.answer !== undefined ||
          questions.q20f1.answer !== undefined ||
          questions.q20f2.answer !== undefined ||
          questions.q20g1.answer !== undefined ||
          questions.q20h1.answer !== undefined ||
          questions.q20i1.answer !== undefined ||
          questions.q20j1.answer !== undefined ||
          questions.q20k1.answer !== undefined ||
          questions.q20l1.answer !== undefined ||
          questions.q20m1.answer !== undefined ||
          questions.q20n1.answer !== undefined ||
          questions.q20o1.answer !== undefined
        ) ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <div className="q26-subtitle">a) Mozek nebo nervový systém</div>
          <div className="mi-3">
            <label>{questions.q20a1.question}</label>
            <YesOrNoRadios skey={"q20a1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{questions.q20a2.question}</label>
            <YesOrNoRadios skey={"q20a2"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{questions.q20a3.question}</label>
            <YesOrNoRadios skey={"q20a3"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{questions.q20a4.question}</label>
            <YesOrNoRadios skey={"q20a4"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{questions.q20a5.question}</label>
            <YesOrNoRadios skey={"q20a5"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">b) Srdce a krevní oběh</div>
          <div className="mi-3">
            <label>{questions.q20b1.question}</label>
            <YesOrNoRadios skey={"q20b1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">c) Zhoubné nádory</div>
          <div className="mi-3 mt-2">
            <YesOrNoRadios skey={"q20c1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">d) Dýchací orgány</div>
          <div className="mi-3">
            <label>{questions.q20d1.question}</label>
            <YesOrNoRadios skey={"q20d1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">e) Zažívací ústrojí</div>
          <div className="mi-3">
            <label>{questions.q20e1.question}</label>
            <YesOrNoRadios skey={"q20e1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">f) Močové cesty a pohlavní orgány</div>
          <div className="mi-3">
            <label>{questions.q20f1.question}</label>
            <YesOrNoRadios skey={"q20f1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="mi-3">
            <label>{questions.q20f2.question}</label>
            <YesOrNoRadios skey={"q20f2"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">g) Onemocnění jater</div>
          <div className="mi-3">
            <label>{questions.q20g1.question}</label>
            <YesOrNoRadios skey={"q20g1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">h) Malárie nebo jiná tropická onemocnění</div>
          <div className="mi-3 mt-2">
            <YesOrNoRadios skey={"q20h1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">i) Jiná infekční a horečnatá onemocnění (případně kontakt s nimi)</div>
          <div className="mi-3">
            <label>{questions.q20i1.question}</label>
            <YesOrNoRadios skey={"q20i1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">j) Onemocnění štítné žlázy nebo slinivky břišní</div>
          <div className="mi-3 mt-2">
            <YesOrNoRadios skey={"q20j1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">k) Poruchy krevní srážlivosti (krvácivost nebo trombózy)</div>
          <div className="mi-3 mt-2">
            <YesOrNoRadios skey={"q20k1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">l) Kožní onemocnění</div>
          <div className="mi-3 mt-2">
            <YesOrNoRadios skey={"q20l1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">m) Cukrovka, dna, zvýšený cholesterol</div>
          <div className="mi-3 mt-2">
            <YesOrNoRadios skey={"q20m1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">n) Zánětlivé onemocnění kloubů</div>
          <div className="mi-3 mt-2">
            <YesOrNoRadios skey={"q20n1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>
          <div className="q26-subtitle">o) Poruchy imunity (včetně autoimunitních onemocnění)</div>
          <div className="mi-3 mt-2">
            <YesOrNoRadios skey={"q20o1"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>
          </div>

        </div>
      },
      {
        title: gender !== "2" ? questions.q21.question : questions.q21.question_female,
        className: questions.q21.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q21"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>



        </div>
      },
      {
        title: gender !== "2" ? questions.q22.question : questions.q22.question_female,
        className: questions.q22.answer !== undefined ? "step-open-by-default" : null,
        description: <div className="mt-2">
          <YesOrNoRadios skey={"q22"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          {questions.q22.answer === true &&

            <SurveyTextarea skey={"q22z"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>

          }


        </div>
      },
      ...(gender !== "1"
        ? [{
          title: gender !== "2" ? questions.q23.question : questions.q23.question_female,
          className: questions.q23.answer !== undefined ? "step-open-by-default" : null,
          description: <div className="mt-2">
            <YesOrNoRadios skey={"q23"} questions={questions} setSurveyAnswer={setSurveyAnswer}/>


          </div>
        }]
        : [])

    ]
  }
}